import { Component, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef, HostListener, ViewEncapsulation } from "@angular/core";
import { IrbRebalanceEditor } from '@irb/irb-editors/irb-editors.rebalance.base';
import { IEvent, IrbAppEvents, IrbEditorsEvents } from "@irb/irb-common/events";
import { RebalanceService } from "../rebalance/rebalance.service";
import { IAnalysisPackage, ICoveredCall, ISaveRebalanceResponse, ICoveredCallAllocation, ISaveRebalanceAsync } from "../rebalance/irb-rebalance.model";
import { IAlertDialogData } from "@irb/app.model";
import { Observable, of } from "rxjs";
import { ISmartFilterDto } from "../irb-editors.model";
import { RebalanceIncludedPortfolioComponent } from '../rebalance/rebalance-included-portfolio/rebalance-included-portfolio.component';
import {AnalyticsService} from "@irb-common/analytics/analytics.service";

@Component({ standalone: false,
    selector: "irb-editor-coveredcall-rebalance",
    templateUrl: "./editor-coveredcall-rebalance.component.html",
    styleUrls: [
        "./editor-coveredcall-rebalance.component.scss",
        "../../irb-common/styles/dialog.scss",
        "../editor-sidebar/editor-sidebar.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None
})
export class EditorCoveredcallRebalanceComponent extends IrbRebalanceEditor {

    @ViewChild("body") body: ElementRef;
    @ViewChild("includedportfolio") includedportfolio: RebalanceIncludedPortfolioComponent;

    defaultExpandedPanels: Array<string>;

    _isReadOnly: boolean = false;

    saveLabel: string = "Process";
    ccHeaderLabel: string;
    analysisName: string = "Covered Call - ";
    analysisType: string = "Covered call";
    isUnitTest: boolean = false;

    constructor(private cdr: ChangeDetectorRef,
        private readonly rebalanceService: RebalanceService,
        public ats: AnalyticsService) {
        super();
        this.identifier = "analysisId";
    }
    getDefaultExpandedPanels() {
        if (this.isReadOnly) {
            this.defaultExpandedPanels = ["REBALANCE_SETTINGS"];
        } else {
            // let source = this.rebalanceService.getRebalanceSource();
            // if(source!==undefined && source !== null && source !=='' && source.length > 0) {
            //     this.defaultExpandedPanels =["REBALANCE_SETTINGS", "REBALANCE_SCHEDULER"];
            // } else {
            //     this.defaultExpandedPanels = ["REBALANCE_SETTINGS", "INCLUDED_PORTFOLIOS", "REBALANCE_SCHEDULER"];
            // }
            // QC 168261
            this.defaultExpandedPanels = ["REBALANCE_SETTINGS", "INCLUDED_PORTFOLIOS", "REBALANCE_SCHEDULER"];

        }
        return this.defaultExpandedPanels;
    }
    get(event: IEvent) {
        super.get(event);
        let eventData: IAnalysisPackage;
        let todayDate = this.datePipe.transform(new Date(), "MM/dd/yyyy");
        if (event.data) {
            this.rebalanceService.setRebalanceSource(event.data.source || null);
        }
        if (event.data !== null && event.data !== undefined && event.data.analysisId !== null && event.data.analysisId !== undefined) {
            eventData = event.data;
            this.rebalanceService.getHistoryDetail(event.data.analysisId).subscribe((data: any) => {
                eventData = data.responseData;
                this.isReadOnly = true;
                this.ccHeaderLabel = "View"
                this.load(eventData);
            });
        } else {

            this.ignoreUnsavedChanges = true;
            this.ccHeaderLabel = "Create";
            eventData = {
                analysisType: this.analysisType,
                tradeExpln: "",
                isSysSuggestion: true,
                isUIAllPort: false,
                analysisName: this.analysisName + todayDate,
                coveredCallDTO: {
                    action: 'SELL_COVER_CALL',
                    isTaxable: true,
                    isQualified: true,
                    buyUsingCashTarget: true,
                    buyUsingCashMinimum: false,
                    allocations: []
                } as ICoveredCall,
                isDeleted: false, isUIdeleted: false, isNew: true, schedulerFrequency: "None",
                smartFilterDto: (event.data && event.data.smartFilterDto) ? event.data.smartFilterDto : {
                    analysisType: this.analysisType,
                    isCategoryAll: false,
                    isCategoryBlank: false,
                    isModelAll: false,
                    isModelBlank: false,
                    modelUpdated: false,
                    sfCategoryDtoList: null,
                    sfModelDtoList: null,
                    smartFilterDays: null,
                    analysisPortDtoList: []
                } as ISmartFilterDto,
                scheduler: {scheduleType: "Adhoc"}
            } as IAnalysisPackage;

            if (event.data && event.data.modelId) {
                eventData.modelId = event.data.modelId;
                eventData.modelName = event.data.modelName;
            }
            
            this.applyRebalanceData(event, eventData, todayDate);
            this.defaultExpandedPanels = this.getDefaultExpandedPanels();
            this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-coveredcall-rebalance", this.defaultExpandedPanels, false);
            this.cdr.detectChanges();
            this.onResize();
        }
        if(event.data.source !== null && event.data.source !== undefined && event.data.source === "rebalancePortfolioDialog"){
            if(this.data.smartFilterDto.analysisPortDtoList !==null && this.data.smartFilterDto.analysisPortDtoList !==undefined){
                this.isReadOnly = false;
                this.isModified = true;
                this.originalData.summarySource = "rebalancePortfolioDialog";
                this.data.tradeExpln = undefined;
                this.cdr.detectChanges();
            }
        }
    }

    load(data: IAnalysisPackage) {
        super.load(data);
        this.defaultExpandedPanels = this.getDefaultExpandedPanels();
        this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-coveredcall-rebalance", this.defaultExpandedPanels, false);
        this.cdr.detectChanges();
        this.onResize();
    }
    
    validateInput(): Observable<string[]> {
        let errors: string[] = [];
        let coveredCall: ICoveredCall = this.data.coveredCallDTO;
        if (coveredCall) {
            if (!coveredCall.isTaxable && !coveredCall.isQualified) {
                errors.push('Select either taxable accounts, qualified accounts, or both to submit this rebalance.');
            }
            if (coveredCall.allocations === null || coveredCall.allocations === undefined || this.isUIDeletedAllocations(coveredCall.allocations)) {
                if(!this.data.isUIAllPort) {
                    errors.push('Add at least one security to this rebalance.');
                }
            } else {
                switch(coveredCall.action) {
                    case 'SELL_COVER_CALL':
                        coveredCall.allocations.filter(allocation => allocation.isUIdeleted === false).forEach((allocation: ICoveredCallAllocation) => {
                            if (allocation.percentOfUnderlyingToCover < 1 || allocation.percentOfUnderlyingToCover > 100) {
                                errors.push('Underlying symbol '+allocation.underlyingSymbol+' requires a value between 1 and 100 for percent of underlying to cover.');
                            }
                        });
                        break;
                    case 'BUY_TO_COVER':
                        coveredCall.allocations.filter(allocation => allocation.isUIdeleted === false).forEach((allocation: ICoveredCallAllocation) => {
                            if (allocation.optionSelectionMode !== 'OPTION_CHAIN') {
                                if (allocation.daysToExpiration === null || allocation.daysToExpiration === undefined || 
                                    (allocation.daysToExpiration < 1 || allocation.daysToExpiration > 365)) {
                                    errors.push('Underlying symbol '+allocation.underlyingSymbol+' requires a value between 1 and 365 for days to expiration.');
                                }
                            }
                        });
                        break;
                    case 'PURCHASE_UNDERLYING_SELL_COVER_CALL':
                        coveredCall.allocations.filter(allocation => allocation.isUIdeleted === false).forEach((allocation: ICoveredCallAllocation) => {
                            if (allocation.underlyingTarget !== null && allocation.underlyingTarget === 'SPECIFY_PERC' && 
                                (allocation.percentOfUnderlyingToPurchase < 1 || allocation.percentOfUnderlyingToPurchase > 100)) {
                                errors.push('Underlying symbol '+allocation.underlyingSymbol+', If underlying target is Specify % then a value is needed in the Underlying % of Portfolio between 0-100.');
                            }
                            if (allocation.percentOfUnderlyingToCover < 1 || allocation.percentOfUnderlyingToCover > 100) {
                                errors.push('Underlying symbol '+allocation.underlyingSymbol+' requires a value between 1 and 100 for percent of underlying to cover.');
                            }
                        });
                        break;
                    case 'ROLL_COVER_CALL':
                        coveredCall.allocations.filter(allocation => allocation.isUIdeleted === false).forEach((allocation: ICoveredCallAllocation) => {
                            if (allocation.optionSelectionMode !== 'OPTION_CHAIN') {
                                if (allocation.daysToExpiration === null || allocation.daysToExpiration === undefined || 
                                    (allocation.daysToExpiration < 1 || allocation.daysToExpiration > 365)) {
                                    errors.push('Underlying symbol '+allocation.underlyingSymbol+' requires a value between 1 and 365 for days to expiration.');
                                }
                            }
                            if (allocation.optionSymbolToRollTo === null || allocation.optionSymbolToRollTo === undefined) {
                                errors.push('Underlying symbol '+allocation.underlyingSymbol+' requires an option symbol to roll to.');
                            }
                        });
                        break;
                }
            }
        }
        
        errors = errors.concat(this.validateDataInput());

        return of(errors);
    }

    isUIDeletedAllocations(allocations: Array<ICoveredCallAllocation>): boolean {
        let isUIDeleted: boolean = true;
        if (allocations.length > 0) {
            for (let i = 0; i < allocations.length; i++) {
                if (!allocations[i].isUIdeleted) {
                    isUIDeleted = false;
                    break;
                }
            }
        }
        return isUIDeleted;
    }

    save() {
        const includePortfolioList = this.includedportfolio.getRowData();
        this.data.smartFilterDto.analysisPortDtoList = includePortfolioList;    
        this.data.smartFilterDto.analysisPortDtoListCount = includePortfolioList.length; 
        this.validateInput().subscribe(errors => {
            if (errors.length > 0) {
                let errMsg: string = errors.join("\n");
                this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                    dTitle: "Alert",
                    msg: errMsg,
                    dProceedBtnLabel: "Ok",
                    dType: "ERROR"
                } as IAlertDialogData);
            } else {
                this.as.fireEvent(IrbEditorsEvents.SAVE_START, { "slot": this.slot });
                delete this.data.navigationSource;
                this.data.scheduler = {"isActive":false,"scheduleType":"Adhoc"};
                this.data.schedulerFrequency = 'None';
                this.trackEditEvent(this.data);

                if(this.data.smartFilterDto.analysisPortDtoList.length >= this.portfolioThreshold) {
                    this.crbservice.saveRebalanceAsync(this.data).subscribe((data: ISaveRebalanceAsync) => {
                        this.checkSaveRebalanceAsyncStatus(data.rprasId);
                    }, () => {
                        this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
                        this.setGlobalError();
                    });
                } else {
                    this.rebalanceService.saveRebalance(this.data).subscribe((data: ISaveRebalanceResponse) => {
                        this.completeSaveRebalance(data);
                    }, () => {
                        this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
                        this.setGlobalError();
                    });
                }
            }
        });
    }

    completeSaveRebalance(response: ISaveRebalanceResponse) {
        if (response.responseStatus === "SUCCESS") {
            if (response.responseUtilityMap != null) {
                let analysisId = response.responseUtilityMap.analysisId;
                let rebalanceResultId = response.responseUtilityMap.rebalanceResultId;
                let rebalanceName = response.responseUtilityMap.rebalanceName;

                let submitTiQueueReq: any = {Package: analysisId+"", RebalanceResult: rebalanceResultId+""};
                this.rebalanceService.submitPortfoliosToQueue(submitTiQueueReq).subscribe(() => {
                    let saveSuccessEventData: {};
                    if (!this.hasPendingFunction) {
                        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                            dTitle: "Rebalance Submitted",
                            msg: rebalanceName,
                            altMsg: "Go to rebalance results summary to check the status of this submission.",
                            dProceedBtnLabel: "Go to Rebalance Result Summary",
                            dType: "WARN",
                            onProceed: (() => {
                                this.router.navigateByUrl("/rebalancing/rebalance-results", { skipLocationChange: true }).then(() => this.router.navigate(["/rebalancing/result-summary/", rebalanceResultId]));
                                this.closeWithoutSave();
                            }).bind(this),
                            onCancel: (() => {
                                this.closeWithoutSave();
                            }).bind(this)
                        } as IAlertDialogData);
                        saveSuccessEventData = { "hasPendingFunction": this.hasPendingFunction, "slot": this.slot };
                    } else {
                        saveSuccessEventData = { "hasPendingFunction": this.hasPendingFunction, "data": rebalanceName+" Rebalance Submitted", "slot": this.slot };
                    }

                    setTimeout(() => { this.as.fireEvent(IrbEditorsEvents.SAVE_SUCCESS, saveSuccessEventData); });
                });
                this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
            }
        } else {
            this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
            this.setGlobalError();
        }
    }

    @HostListener("window:resize", ["$event"])
    onResize() {
        if (this.body) {
            const rect = this.body.nativeElement.getBoundingClientRect();
            let h = (window.innerHeight - rect.top - 10);

            h = (h < 200) ? 200 : h;
            this.bodyHeight = h + "px";
        }
    }

    get data() {
        return this._data;
    }

    set data(newData: any) {
        this._data = newData;
    }

    get isReadOnly() {
        return this._isReadOnly;
    }

    set isReadOnly(isReadOnly: boolean) {
        this._isReadOnly = isReadOnly;
    }

    getPortfolioCount() {
        if(this.data && this.data.isUIAllPort && this.data.isUIAllPort == true) {
            return "All portfolios included";
        }
        if(this.data?.smartFilterDto?.analysisPortDtoList !==null
            && this.data?.smartFilterDto?.analysisPortDtoList !==undefined
            && this.data?.smartFilterDto?.analysisPortDtoList?.length) {
            if(this.data?.smartFilterDto?.analysisPortDtoList?.length > 1) {
                return this.data?.smartFilterDto?.analysisPortDtoList?.length + " portfolios included";
            } else if (this.data?.smartFilterDto?.analysisPortDtoList?.length === 1) {
                return this.data?.smartFilterDto?.analysisPortDtoList?.length + " portfolio included";
            } else {
                return 0 + " portfolios included";
            }
        } else {
            return 0 + " portfolios included";
        }
    }
}
